import type { RefObject } from 'react'

import {
    gsap,
    registerGsap,
    useGSAP
} from '@/lib/gsap'

/**
 * Infinite rotation, recreated from the Webflow PAGE_START loop (IX2 list
 * a-58, a 360deg rotation over 30s). Any element opts in with:
 *
 *   data-spin                  marker (required)
 *   data-spin-duration="30"    seconds per full turn (optional)
 *   data-spin-direction="cw|ccw"
 */
export const useSpin = (scope: RefObject<HTMLElement | null>): void => {
    useGSAP(
        () => {
            registerGsap()

            const root = scope.current
            if (!root) return

            const elements = root.querySelectorAll<HTMLElement>('[data-spin]')

            elements.forEach(element => {
                const duration = Number(element.dataset.spinDuration) || 30
                const counter = element.dataset.spinDirection === 'ccw'

                gsap.to(element, {
                    rotation: counter ? -360 : 360,
                    duration,
                    ease: 'none',
                    repeat: -1
                })
            })
        },
        { scope }
    )
}
